import { NgFor } from '@angular/common';
import { Component, Inject, Input } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { BottomSheetItem } from './bottom-sheet-item.model';

export interface BottomSheetSelectorData {
  title: string;
  elementsList: BottomSheetItem[];
}

@Component({
  selector: 'cloud-bottom-sheet-selector',
  templateUrl: './bottom-sheet-selector.component.html',
  standalone: true,
  imports: [NgFor, MatListModule],
})
export class BottomSheetSelectorComponent {
  @Input() title = '';
  @Input() elementsList: BottomSheetItem[] = [];

  constructor(
    public bottomSheetRef: MatBottomSheetRef<BottomSheetSelectorComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: BottomSheetSelectorData
  ) {
    this.title = data.title;
    this.elementsList = data.elementsList;
  }
}
